import { connectTenvideoJSBridge } from '@iv/adapter-bridge/src/tenvideoWeb/module/bridge';
/**
 * 音频播放类
 * @class AudioPlayer
 */
class AudioPlayer {
  private audio: HTMLAudioElement;
  private loop: boolean;
  private currentTime: number;

  public constructor(config?: { url: string }) {
    if (!config) {
      this.audio = new Audio();
      return;
    }
    this.audio = new Audio(config.url || '');
    this.loop = false;
    if (typeof this.audio.loop !== 'boolean') {
      this.audio.addEventListener(
        'ended',
        () => {
          if (this.loop) {
            this.currentTime = 0;
            this.play();
          }
        },
        false,
      );
    }
  }

  // 设置循环
  public setLoop(loop: boolean) {
    this.loop = loop;
    if (typeof this.audio.loop === 'boolean') {
      this.audio.loop = loop;
    }
  }

  // 预加载
  public load(src: string) {
    this.audio.pause();
    this.loop = false;
    this.audio.src = src;
  }

  // 播放
  public play(time?: number) {
    if (time || time === 0) {
      this.audio.pause();
      this.audio.currentTime = time;
    }
    const promise = this.audio.play();
    if (promise !== undefined) {
      promise
        .then(() => {})
        .catch((e) => {
          console.warn('music Autoplay failed! ', e);
        });
    }
  }

  // 暂停
  public stop() {
    this.audio.pause();
  }

  // 清空
  public end() {
    this.audio.pause();
    this.audio.src = '';
  }

  public mute() {
    this.audio.muted = true;
  }

  public unmute() {
    this.audio.muted = false;
  }
}

/**
 * 音频池子
 * @class Music
 */
class Music {
  public audioList: Array<AudioPlayer>;

  private preloadNum: number;
  private audioMap: { [key: string]: AudioPlayer };
  private available: boolean;

  public constructor() {
    // 预启用的音频个数
    this.preloadNum = 5;
    // id对应audio资源地址
    this.audioMap = {};
    // 预绑定自动播放hack
    this.autoPlayHack();
    // 是否可用
    this.available = true;

    connectTenvideoJSBridge((bridge: any) => {
      bridge.$on('onAppEnterBackground', () => {
        this.disable();
      });
      bridge.$on('onAppEnterForeground', () => {
        this.enable();
      });
    });
  }

  // 自动播放hack
  public autoPlayHack() {
    this.audioList = [];
    for (let i = 0; i < this.preloadNum; i += 1) {
      this.audioList.push(new AudioPlayer());
    }
    let hasStart = false;
    document.body.addEventListener('touchstart', () => {
      if (!hasStart) {
        hasStart = true;
        this.audioList.forEach((audio) => {
          audio.play();
        });
      }
    });
  }

  // 加载音频
  public loadFile(soundInfo: { id: string; src: string }) {
    const { id, src } = soundInfo;

    if (this.audioMap[id]) {
      console.warn('id已经占用');
      return;
    }

    if (this.audioList.length) {
      const audio = this.audioList.pop();
      audio.load(src.replace('http:', ''));
      this.audioMap[id] = audio;
    } else {
      const audio = new AudioPlayer({
        url: src.replace('http:', ''),
      });
      if (!this.available) audio.mute();
      this.audioMap[id] = audio;
    }
  }

  // 播放音频
  public play(playInfo: { id: string; loop: boolean; time: number }) {
    const { id, time, loop } = playInfo;
    if (!id) {
      console.warn('播放id为空');
      return;
    }
    const startTime = time || 0;
    this.audioMap[id].play(startTime);
    this.audioMap[id].setLoop(loop);
  }

  // 暂停音频
  public stop(id: string) {
    if (!id) {
      console.warn('暂停id为空');
      return;
    }
    this.audioMap[id].stop();
  }

  // 清除音频
  public end(id: string) {
    if (!this.audioMap[id]) return;
    this.audioMap[id].end();
    this.audioList.push(this.audioMap[id]);
    delete this.audioMap[id];
  }

  // 清除全部音频
  public endAll() {
    Object.keys(this.audioMap).forEach((id) => {
      this.end(id);
    });
  }

  // 禁用音效 暂停所有声音
  public disable() {
    this.available = false;
    Object.keys(this.audioMap).forEach((id) => {
      this.audioMap[id].mute();
    });
  }

  public enable() {
    this.available = true;
    Object.keys(this.audioMap).forEach((id) => {
      this.audioMap[id].unmute();
    });
  }
}

const audioInstance = new Music();

export default audioInstance;
